import React from 'react'
import data from '../Assets/Datas/data'
import { Container } from 'react-bootstrap'
import Slide from '../Components/Slider/Slide'
import Grid from '../Components/Grid'
import Quality from '../Components/Quality'
import Contact from '../Components/Contact'
import { Helmet } from 'react-helmet-async'





const Home = () => {
  const slideImages = data.filter(item => item.sect === 'slide');
  const slide = data.filter(item => item.sect === 'heroSlider');
  return (
    <div> 
      <Helmet>
        <title>Oyoyo lubricant - Home</title>
        <meta
          name="description"
          content="Engineered with a superior UAE formula, our oil is crafted from high-quality base oils and enhanced with advanced additives, making it perfect for use in passenger cars, minibuses, vans, commercial trucks, and more."
        />
        <link rel="canonical" href="https://oyoyolubricant.com/" />
      </Helmet>
      <div className='bg-accent1 py-2 text-sm text-slate-500 underline cursor-pointer '>
        <Container><p>Oyoyo Lubricants &rarr; Home</p></Container>
      </div>
      <div className="border-b-yellow-500 border-b-8">
        <Container className=''>
          <h1 className='text-3xl md:text-4xl font-semibold tracking-wider text-primary-300 subpixel-antialiased  mb-3'>Oyoyo lubricants</h1>
          <Slide slideData={slideImages}/>
        </Container>
      </div>
      <Quality />
      <Grid data={slide}/>
      <Contact />
    </div>
  )
}
export default Home
